import { useState } from 'react';

const galleryImages = [
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/feba477826d2ae7c21088afd07ebb78d.jpeg',
    title: 'Christmas Express'
  },
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/9f7667f9c5b7304630e8377bd0c60a2b.jpeg',
    title: 'Halloween Adventure'
  },
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/7dcfd2f2af698d32622a328f818b94f1.jpeg',
    title: 'Special Needs Program'
  },
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/103ad9d73425949df6ecaea88b062b7b.jpeg',
    title: 'Birthday Celebration'
  },
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/b9d1feaa26b17f9474fc285decc13812.jpeg',
    title: 'Community Event'
  },
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/6051cc78b577201f7f3fa16b2b2e05f9.jpeg',
    title: 'Easter Spring Ride'
  },
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/b88beb930c48a2588efb64e2c8829d90.jpeg',
    title: 'Holiday Night Ride'
  },
  {
    url: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/9cdc48c12eb7e289bf07f2d0ac7dddab.jpeg',
    title: 'Summer Festival Fun'
  }
];

export default function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <section id="gallery" className="py-24 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6 px-6 py-2 bg-red-600 rounded-full">
            <span className="text-white text-sm font-semibold uppercase tracking-wide">Memories</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            See the Joy We Create
          </h2>
          <p className="text-xl text-white/60">
            Browse our collection of magical moments
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden mb-8">
            <div className="w-full h-[700px]">
              <img
                src={galleryImages[currentIndex].url}
                alt={galleryImages[currentIndex].title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="absolute top-6 right-6 px-4 py-2 bg-black/70 rounded-full">
              <span className="text-white text-sm font-semibold">
                {currentIndex + 1} / {galleryImages.length}
              </span>
            </div>

            <button
              onClick={prevSlide}
              className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-red-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-red-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>

          <div className="flex justify-center gap-3 flex-wrap">
            {galleryImages.map((image, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-32 h-20 rounded-lg overflow-hidden border-3 transition-all cursor-pointer ${
                  index === currentIndex ? 'border-red-600' : 'border-white/30 hover:border-white/60'
                }`}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}